import product1img1 from './img/shop/shop1/n1.jpg'
import product1img2 from './img/shop/shop1/n2.jpg'
import product1img3 from './img/shop/shop1/n3.jpg'

import product2img1 from './img/shop/shop1/le1.jpeg'
import product2img2 from './img/shop/shop1/le2.jpg'
import product2img3 from './img/shop/shop1/le3.jpg'

import product3img1 from './img/shop/shop1/i1.jpg'
import product3img2 from './img/shop/shop1/i2.jpg'
import product3img3 from './img/shop/shop1/i3.jpg'

import product4img1 from './img/shop/shop1/g1.jpg'
import product4img2 from './img/shop/shop1/g2.jpg'
import product4img3 from './img/shop/shop1/g3.jpg'

import product5img1 from './img/shop/shop1/s2.jpeg'
import product5img2 from './img/shop/shop1/s1.jpg'
import product5img3 from './img/shop/shop1/s3.jpg'

import product6img1 from './img/shop/shop1/genos1.jpg'
import product6img2 from './img/shop/shop1/genos2.jpg'
import product6img3 from './img/shop/shop1/genos3.jpg'

import product7img1 from './img/shop/shop1/k1.jpg'
import product7img2 from './img/shop/shop1/k3.jpg'
import product7img3 from './img/shop/shop1/k2.jpg'

import product8img1 from './img/shop/shop1/ki3.jpg'
import product8img2 from './img/shop/shop1/ki1.jpg'
import product8img3 from './img/shop/shop1/ki2.jpg'

export const PRODUCTS = [
    {   
        id: 1,
        amount: 1,
        route: 'product1',
        name: "AniStore",
        title: "Naruto Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product1img2,
        image2: product1img1,
        image3: product1img3,
    },
    {   
        id: 2,
        amount: 1,
        route: 'product2',
        name: "AniStore",
        title: "Rock Lee Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product2img1,
        image2: product2img2,
        image3: product2img3,
    },
    {   
        id: 3,
        amount: 1,
        route: 'product3',
        name: "AniStore",
        title: "Itachi Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product3img3,
        image2: product3img2,
        image3: product3img1,
    },
    {
        id: 4,
        amount: 1,
        route: 'product4',
        name: "AniStore",
        title: "Zenitsu Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product7img2,
        image2: product7img1,
        image3: product7img3,
    },
    {
        id: 5,
        amount: 1,
        route: 'product5',
        name: "AniStore",
        title: "Goku Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product4img2,
        image2: product4img1,
        image3: product4img3,
    },
    {
        id: 6,
        amount: 1,
        route: 'product6',
        name: "AniStore",
        title: "Killua Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product8img1,
        image2: product8img2,
        image3: product8img3,
    },
    {   
        id: 7,
        amount: 1,
        route: 'product7',
        name: "AniStore",
        title: "Saitama Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product5img1,
        image2: product5img2,
        image3: product5img3,
    },
    {
        id: 8,
        amount: 1,
        route: 'product8',
        name: "AniStore",
        title: "Genos Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product6img1,
        image2: product6img2,
        image3: product6img3,
    },
]